import FailedBooking from "pages/Website/ConfirmBooking/FailedBooking";
import ConfirmCharge from "pages/Website/ConfirmBooking/ConfirmCharge";
import { lazy } from "react";

// ── Code-split each page so the initial bundle stays small ─────────────────
const Pages404 = lazy(() => import("pages/Utility/pages-404"));
const Pages500 = lazy(() => import("pages/Utility/pages-500"));

const Authentication = lazy(() => import("pages/Website/Authentication"));
const Booking = lazy(() => import("pages/Website/Booking"));
const ConfirmBooking = lazy(() => import("pages/Website/ConfirmBooking"));
const GameDetails = lazy(() => import("pages/Website/GameDetails"));
const GamesPage = lazy(() => import("pages/Website/Games"));
const Home = lazy(() => import("pages/Website/Home"));
const MyBookings = lazy(() => import("pages/Website/MyBookings"));
const MyWallet = lazy(() => import("pages/Website/MyWallet"));
const Profile = lazy(() => import("pages/Website/Profile"));

// Settings / Static Pages
const Terms = lazy(() => import("pages/Website/Settings/Terms"));
const Cancellation = lazy(() => import("pages/Website/Settings/Cancellation"));
const BookingPolicy = lazy(
	() => import("pages/Website/Settings/BookingPolicy"),
);
const FAQs = lazy(() => import("pages/Website/Settings/FAQs"));
const HelpCenter = lazy(() => import("pages/Website/Settings/HelpCenter"));
const PrivacyPolicy = lazy(
	() => import("pages/Website/Settings/PrivacyPolicy"),
);
const CookiePolicy = lazy(() => import("pages/Website/Settings/CookiePolicy"));
const Sitemap = lazy(() => import("pages/Website/Settings/Sitemap"));

// Navbar Pages
const AboutUs = lazy(() => import("pages/Website/AboutUs"));
const Support = lazy(() => import("pages/Website/Support"));

const websiteRoutes = [
	{ path: "/my-bookings", component: MyBookings },
	{ path: "/my-wallet", component: MyWallet },
	{ path: "/profile", component: Profile },
	{ path: "/game-details/:id/booking", component: Booking },
	{ path: "/failed-booking", component: FailedBooking },
	{ path: "/confirm-booking", component: ConfirmBooking },
	{ path: "/confirm-booking/:id", component: ConfirmBooking },
	{ path: "/confirm-charge", component: ConfirmCharge },
];

const websiteAuthRoutes = [
	// 🔹 Public Pages
	{ path: "/", component: Home },
	{ path: "/games", component: GamesPage },

	// 🔹 Game Flow
	{ path: "/game-details/:id", component: GameDetails },

	// 🔹 Auth
	{ path: "/login", component: Authentication },
	{ path: "/register", component: Authentication },
	{ path: "/forget-password", component: Authentication },

	// 🔹 Navbar Pages
	{ path: "/about-us", component: AboutUs },
	{ path: "/support", component: Support },

	// 🔹 Settings / Static Pages
	{ path: "/terms", component: Terms },
	{ path: "/cancellation", component: Cancellation },
	{ path: "/booking-policy", component: BookingPolicy },
	{ path: "/faqs", component: FAQs },
	{ path: "/help-center", component: HelpCenter },
	{ path: "/privacy-policy", component: PrivacyPolicy },
	{ path: "/cookie-policy", component: CookiePolicy },
	{ path: "/sitemap", component: Sitemap },

	// 🔹 Error Pages
	{ path: "/pages-500", component: Pages500 },

	// ❗ IMPORTANT: Catch-all (MUST be last)
	{ path: "*", component: Pages404 },
];

export { websiteAuthRoutes, websiteRoutes };
